var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"detail pcm"},[_c('div',{staticClass:"el-header",class:_vm.$route.name==='UserPay'?'shadow':''},[_c('NavHeader')],1),_c('div',{staticClass:"el-main",class:_vm.$route.name==='UserPay'?'bg-gray':'',attrs:{"id":"main"}},[_c('router-view')],1),_c('div',{staticClass:"el-footer"},[_c('Footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }